export default __webpack_public_path__ + "static/media/19_header_stock.421606da.png";